/**
 * Demo mode for the campaign screens: the in-browser adapters and no network.
 *
 * On for the no-sign-in pages (`/preview/*`, `/start*`), for `?dev=1`, and
 * when `localStorage['ff-free-flow']` is "1". Kept inside the campaign
 * module so it has no dependency on the onboarding module's dev tools.
 */
const FREE_FLOW_KEY = 'ff-free-flow'

export const isFreeFlow = (): boolean => {
   if (typeof window === 'undefined') return false
   const { pathname, search } = window.location
   if (/^\/(preview|start)(\/|$)/.test(pathname)) return true
   if (new URLSearchParams(search).get('dev') === '1') return true
   try {
      return window.localStorage.getItem(FREE_FLOW_KEY) === '1'
   } catch {
      return false
   }
}

/** For SWR keys: `useSWR(gated(key), fetcher)` fetches nothing in demo mode. */
export const gated = <T>(key: T): T | null => (isFreeFlow() ? null : key)
